import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-excel",
  "use": "foquz-icon-excel-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" id=\"foquz-icon-excel\"><path d=\"M8.475 3.125h2.107L8.057 6.854 10.907 11H8.72L6.984 8.438 5.248 11H3.062l2.85-4.146-2.526-3.729h2.107l1.491 2.17 1.491-2.17z\" fill=\"currentColor\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0v14h14V0H0zm2 2v10h10V2H2z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol